import { TheWestSection } from '@news-mono/common'
import { StaticRoute, StaticRoutes } from '@news-mono/web-common'
import { getSwgLandingPage } from '../regionals/get-swg-landing-page'

const createFreeTrialOfferPage: StaticRoute<TheWestSection> = (services) => {
    if (!services.store.getState().toggles['free-trial-google-offer'])
        return null
    return getSwgLandingPage({
        section: 'default',
        getAdTargeting: services.getAdTargeting,
        toggles: services.store.getState().toggles,
        logger: services.log,
        options: {
            modifier: 'free-trial-offer',
            noIndex: true,
            desiredRedirect: `${services.protocol}//${services.hostname}`,
        },
    })
}

export const getFreeTrialOfferRouteInfo: StaticRoutes<TheWestSection> = {
    '/googlefreetrial': createFreeTrialOfferPage,
}
